import { useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

import { getBrochureUrl } from "../../services/EventMasterService";

function EventBrochurePopup({ event, loading, canEdit, onClose, onUpload, onError }) {
  const [fileError, setFileError] = useState("");
  const inputRef = useRef(null);

  if (!event) return null;

  async function handleBrochureSelection(fileEvent) {
    const file = fileEvent.target.files?.[0];
    if (!file) return;

    if (file.size > 10 * 1024 * 1024) {
      const message = "Brochure file must be 10MB or smaller.";
      setFileError(message);
      onError?.(message);
      fileEvent.target.value = "";
      return;
    }

    setFileError("");
    try {
      await onUpload?.(event.eventID, file);
    } catch (error) {
      onError?.(error?.message || "Unable to upload brochure.");
    } finally {
      fileEvent.target.value = "";
    }
  }

  function handleOpenBrochure() {
    if (!event?.brochurePath) {
      onError?.("No brochure is available for this event.");
      return;
    }
    window.open(getBrochureUrl(event.eventID), "_blank", "noopener,noreferrer");
  }

  return (
    <Dialog open={Boolean(event)} onClose={onClose} maxWidth="sm" fullWidth>
      <input
        ref={inputRef}
        type="file"
        accept=".pdf,.doc,.docx,image/*"
        hidden
        onChange={handleBrochureSelection}
      />
      <DialogTitle>
        <Typography variant="overline" display="block" color="text.secondary">
          Event Brochure
        </Typography>
        {event.name}
      </DialogTitle>
      <DialogContent dividers>
        {fileError ? (
          <Typography color="error">{fileError}</Typography>
        ) : event?.brochurePath ? (
          <Typography color="text.secondary">
            A brochure is uploaded for this event. Use Open File to view it.
          </Typography>
        ) : (
          <Typography color="text.secondary">No brochure uploaded yet.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        {canEdit && (
          <Button
            variant="outlined"
            onClick={() => inputRef.current?.click()}
            disabled={loading}
          >
            {event?.brochurePath ? "Change Brochure" : "Upload Brochure"}
          </Button>
        )}
        {event?.brochurePath && (
          <Button variant="outlined" onClick={handleOpenBrochure}>
            Open File
          </Button>
        )}
        <Button variant="contained" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EventBrochurePopup;
